var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89375 9.70625L5.05625 7.86875C4.94375 7.75625 4.80625 7.7 4.64375 7.7C4.48125 7.7 4.34375 7.75625 4.23125 7.86875C4.10625 7.99375 4.04375 8.14063 4.04375 8.30938C4.04375 8.47813 4.1 8.61875 4.2125 8.73125L6.5 11.0187C6.6 11.1187 6.73125 11.1688 6.89375 11.1688C7.05625 11.1688 7.1875 11.1187 7.2875 11.0187L11.7875 6.51875C11.9 6.40625 11.9562 6.26875 11.9562 6.10625C11.9562 5.94375 11.8938 5.8 11.7687 5.675C11.6562 5.5625 11.5156 5.50625 11.3469 5.50625C11.1781 5.50625 11.0312 5.56875 10.9062 5.69375L6.89375 9.70625ZM8 15.5C6.9375 15.5 5.95 15.3094 5.0375 14.9281C4.125 14.5469 3.33125 14.0188 2.65625 13.3438C1.98125 12.6687 1.45312 11.875 1.07188 10.9625C0.690625 10.05 0.5 9.0625 0.5 8C0.5 6.95 0.690625 5.96875 1.07188 5.05625C1.45312 4.14375 1.98125 3.35 2.65625 2.675C3.33125 2 4.125 1.46875 5.0375 1.08125C5.95 0.69375 6.9375 0.5 8 0.5C9.05 0.5 10.0312 0.69375 10.9438 1.08125C11.8562 1.46875 12.65 2 13.325 2.675C14 3.35 14.5312 4.14375 14.9188 5.05625C15.3063 5.96875 15.5 6.95 15.5 8C15.5 9.0625 15.3063 10.05 14.9188 10.9625C14.5312 11.875 14 12.6687 13.325 13.3438C12.65 14.0188 11.8562 14.5469 10.9438 14.9281C10.0312 15.3094 9.05 15.5 8 15.5Z",
    fill: "#222529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon_check.8cccbf1db533245573223e535e772878.svg";
export { ForwardRef as ReactComponent };